<template>
  <!-- <div>
    <div class="row">
      <div class="col">
        <SubMenu2 />
        <Timeline />
  </div>-->
  <div class="col-3">
    <!-- <h1>Was möchten Sie in Dachau weiter-denken?</h1> -->
    <p>
      Insgesamt haben bei der Bürgerbeteiligung
      <strong>484</strong> Personen mitgemacht. Die Daten für die digitale Auswertung wurden vorab bereinigt und dabei wurden einige wenige Kommentare unberücksichtigt gelassen. Ausgeschlossen wurden Wiederholungen und Kommentare, die nicht sinnvoll eingeordnet werden konnten. Das Auswertungsportal stellt ein Angebot zur Übersicht über die vielzähligen Einträge dar, aufgrund der interessanten Einzelbeiträge an bestimmten Orten bleiben natürlich alle Beiträge in der Rubrik
      <router-link :to="{name: 'karte'}">{{'Interaktive Karte '}}</router-link>bestehen.
    </p>
    <p>
      Klicken Sie in der Karte auf einen Stadtteil oder auf den schwarzen Pfeil auf der rechten Seite, um sich die prozentuale Verteilung der Themenfelder anzeigen zu lassen. Dort können Sie auch zwischen der Untergliederung in Bezirke und Stadtteile wählen und einzelne Themenfelder im Detail betrachten. Unter
      <router-link to="/aktuelles">{{'Aktuelles '}}</router-link>informieren wir Sie auch über die anderen Beteiligungsformate und deren Ergebnis.
    </p>
    <hr />
    <Auswertung />
  </div>
  <!-- </div>
  </div>-->
</template>

<script>
import Auswertung from "@/components/MachMit/Auswertung.vue";
import Timeline from "@/components/Timeline.vue";

export default {
  components: {
    Auswertung,
    Timeline
  },
  data() {
    return {};
  },
  mounted() {
    if (this.$store.state.user) {
      this.$router.push("/machmit/karte/user/" + this.$store.state.user);
    }
  },
  methods: {
    showForm() {}
  }
};
</script>
<style scoped lang="scss">
</style>